export const Layout = () => import('@/layout/index.vue')
import { getRouteRoles } from '@/utils/index'

/**
 * 标签印刷AI订单系统路由
 */
const routes = {
  path: '/datacenter',
  redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'Document',
    title: '数据中心',
    roles: [],
    activeMenuTop: '/datacenter',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  },
  children: [
    {
      path: 'customer',
      name: 'CustomerList',
      component: () => import('@/views/datacenter/customer/list.vue'),
      meta: {
        title: '客户管理',
        icon: 'List',
        roles: ['admin/label.Order/list'],
        activeMenuTop: '/datacenter',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'customer',
      name: 'OrderList',
      component: () => import('@/views/datacenter/order/list.vue'),
      meta: {
        title: '订单管理',
        icon: 'User',
        roles: ['admin/label.Customer/list'],
        activeMenuTop: '/datacenter',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/datacenter/dashboard/info.vue'),
      meta: {
        title: 'Dashshboard',
        icon: 'Money',
        roles: ['admin/label.PriceRule/list'],
        activeMenuTop: '/datacenter',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'statistics',
      name: 'Statistics',
      component: () => import('@/views/datacenter/statistics/info.vue'),
      meta: {
        title: '统计报表',
        icon: 'Connection',
        roles: ['admin/label.Channel/list'],
        activeMenuTop: '/datacenter',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    }
  ]
}

routes.meta.roles = getRouteRoles(routes)

export default routes
